<template>
  <div class="sync-status">
    <div class="status-indicator" :class="statusClass">
      <span class="status-dot"></span>
      <span class="status-text">{{ statusText }}</span>
    </div>
    
    <button @click="toggleAutoRefresh" class="btn btn-sm btn-outline" :title="autoRefreshTitle">
      <span v-if="appStore.autoRefresh">⏸️</span>
      <span v-else>▶️</span>
    </button>
  </div>
</template>

<script>
import { useAppStore } from '@/stores/appStore'

export default {
  name: 'SyncStatus',
  setup() {
    const appStore = useAppStore()
    
    // Start auto refresh when component mounts
    appStore.startAutoRefresh()
    
    return {
      appStore
    }
  },
  
  computed: {
    statusClass() {
      const health = this.appStore.systemHealth
      return {
        'status-ok': health === 'ok',
        'status-active': health === 'active', 
        'status-warning': health === 'warning',
        'status-error': health === 'error',
        'status-unknown': health === 'unknown'
      }
    },
    
    statusText() {
      const health = this.appStore.systemHealth
      switch (health) {
        case 'ok': return 'System OK'
        case 'active': return 'Sync Active'
        case 'warning': return 'Warnings'
        case 'error': return 'Errors'
        default: return 'Checking...'
      }
    },
    
    autoRefreshTitle() {
      return this.appStore.autoRefresh ? 'Pause auto refresh' : 'Resume auto refresh'
    }
  },
  
  methods: {
    toggleAutoRefresh() {
      this.appStore.toggleAutoRefresh()
    }
  }
}
</script>

<style scoped>
.sync-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.status-ok {
  background-color: rgba(25, 135, 84, 0.2);
  color: #198754;
}

.status-ok .status-dot {
  background-color: #198754;
}

.status-active {
  background-color: rgba(13, 110, 253, 0.2);
  color: #0d6efd;
}

.status-active .status-dot {
  background-color: #0d6efd;
}

.status-warning {
  background-color: rgba(255, 193, 7, 0.2);
  color: #ffc107;
}

.status-warning .status-dot {
  background-color: #ffc107;
}

.status-error {
  background-color: rgba(220, 53, 69, 0.2);
  color: #dc3545;
}

.status-error .status-dot {
  background-color: #dc3545;
}

.status-unknown {
  background-color: rgba(108, 117, 125, 0.2);
  color: #6c757d;
}

.status-unknown .status-dot {
  background-color: #6c757d;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}
</style>